<template>
  <PrimaryModal @clickBackground="onClose">
    <div class="pt-6 pb-4 mx-6 modal-size">
      <MonacoEditorFreeSpace class="min-h-0 w-full h-full border select-none dark:border-dark-200" />
    </div>
    <div>
      <div class="w-full flex items-center justify-center px-6">
        <button
          class="relative mb-2 focus:outline-none font-bold shadow-md border-2 hover:border-gray-600 hover:text-gray-600 bg-white border-gray-700 text-gray-700 dark:bg-dark-200 dark:border-dark-200 dark:text-dark-text dark:hover:border-dark-10 dark:hover:bg-dark-10"
          :class="{
            'base-texticon-click-effect': isLightMode(),
            'base-texticon-click-effect-dark': !isLightMode()
          }"
          :disabled="isTestLoading"
          style="width: 100px; height: 30px; border-radius: 1rem"
          type="submit"
          @click="clickTestSubmit"
        >
          {{ isTestLoading ? '' : $t('message.run') }}
        </button>
      </div>
      <div
        v-if="
          freeSpaceState.isErrorShow.value &&
          !isTestLoading &&
          freeSpaceJudgeDetailState.judgeDetail.value &&
          (freeSpaceJudgeDetailState.judgeDetail.value.compileError ||
            freeSpaceJudgeDetailState.judgeDetail.value.runtimeError)
        "
        class="px-6"
      >
        <ErrorMessage
          :errorText="freeSpaceState.errorMessage.value"
          :testJudgeDetail="freeSpaceJudgeDetailState.judgeDetail.value"
        />
      </div>
      <div class="flex mx-4">
        <InputConsole
          class="p-2"
          :isEditable="!isTestLoading"
          :label="$t('message.input')"
          :onChange="freeSpaceState.setTestInput"
          :value="freeSpaceState.testInput.value"
        />
        <OutputConsole class="p-2" :isEditable="false" :label="$t('message.output')" />
      </div>
    </div>
  </PrimaryModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import ErrorMessage from './children/ErrorMessage.vue'
import InputConsole from './children/InputConsole.vue'
import MonacoEditorFreeSpace from './children/MonacoEditorFreeSpace.vue'
import OutputConsole from './children/OutputConsole.vue'

import PrimaryModal from '@/presentation/components/Modal/PrimaryModal.vue'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useFreeSpaceJudgeDetailPresenter } from '@/presentation/composables/freeSpace/useFreeSpaceJudgeDetailPresenter'
import { useFreeSpaceStatePresenter } from '@/presentation/composables/freeSpace/useFreeSpaceStatePresenter'
import { useJudgeStatePresenter } from '@/presentation/composables/judge/useJudgeStatePresenter'
import { usePostTestSubmissionPresenter } from '@/presentation/composables/judge/usePostTestSubmissionPresenter'
import { useModalStatePresenter } from '@/presentation/composables/modal/useModalStatePresenter'

export default defineComponent({
  components: {
    PrimaryModal,
    MonacoEditorFreeSpace,
    InputConsole,
    OutputConsole,
    ErrorMessage
  },
  setup(props, ctx) {
    const freeSpaceState = useFreeSpaceStatePresenter()
    const freeSpaceJudgeDetailState = useFreeSpaceJudgeDetailPresenter()

    const { setIsShowFreeSpaceModal } = useModalStatePresenter()

    const { postTestSubmission } = usePostTestSubmissionPresenter()
    const { programLanguage, isLightMode } = useConfigStatePresenter()

    const { isTestLoading } = useJudgeStatePresenter()

    const clickTestSubmit = () => {
      postTestSubmission('8080', programLanguage.value, freeSpaceState.sourceCode.value, 'completelyFreespace')
    }

    const onClose = () => {
      setIsShowFreeSpaceModal(false)
    }

    return {
      onClose,
      clickTestSubmit,
      isLightMode,
      isTestLoading,
      freeSpaceState,
      freeSpaceJudgeDetailState
    }
  }
})
</script>

<style lang="postcss" scoped>
.modal-size {
  width: 70vw;
  height: 50vh;
  max-height: 100%;
}

.loading::before {
  position: absolute;
  content: '';
  top: 0.4rem;
  left: 40%;
  transform: translateX(-50%);
  width: 1rem;
  height: 1rem;
  border: 2px gray solid;
  border-bottom: 2px transparent solid;
  border-radius: 50%;
  animation: 1000ms linear 0ms infinite running rotate;
}
@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
